module.exports = __webpack_public_path__ + "static/img/cp_2.e3fc7e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cp_2.png
// module id = jgVJ
// module chunks = 0